/** Opportunity lifecycle — align with planned API enums */
export const OPPORTUNITY_STATUS = {
  DRAFT: "draft",
  INTERNAL_REVIEW: "internal_review",
  SCHEDULED: "scheduled",
  PUBLISHED: "published",
  FUNDING: "funding",
  FULLY_FUNDED: "fully_funded",
  ACTIVE: "active",
  MATURED: "matured",
  CLOSED: "closed",
  ARCHIVED: "archived",
};

/** Investment request lifecycle */
export const INVESTMENT_REQUEST_STATUS = {
  PENDING_PAYMENT: "pending_payment",
  SUBMITTED: "submitted",
  UNDER_REVIEW: "under_review",
  APPROVED: "approved",
  DECLINED: "declined",
  ALLOCATED: "allocated",
  MATURED: "matured",
  CANCELLED: "cancelled",
};

export const PARTICIPANT_TYPE = {
  STANDALONE_INVESTOR: "standalone_investor",
  COOPERATIVE_MEMBER: "cooperative_member",
};

export const KYC_STATUS = {
  NONE: "none",
  PENDING: "pending",
  APPROVED: "approved",
  REJECTED: "rejected",
};

export const ACCOUNT_STATUS = {
  ACTIVE: "active",
  SUSPENDED: "suspended",
  PENDING_VERIFICATION: "pending_verification",
};

export const UPDATE_STATUS = {
  DRAFT: "draft",
  PUBLISHED: "published",
  SCHEDULED: "scheduled",
};

export const DOCUMENT_VISIBILITY = {
  PUBLIC: "public",
  INVESTORS: "investors",
  PRIVATE: "private",
};

export const OPPORTUNITY_STATUS_COLORS = {
  draft: "#A1A0A0",
  internal_review: "#0556e5",
  scheduled: "#8543f1",
  published: "#19BC31",
  funding: "#31778C",
  fully_funded: "#31778C",
  active: "#19BC31",
  matured: "#525252",
  closed: "#525252",
  archived: "#383838",
  unpublished: "#FFA500",
};

export const REQUEST_STATUS_COLORS = {
  pending_payment: "#FFA500",
  submitted: "#FFA500",
  under_review: "#0556e5",
  approved: "#19BC31",
  declined: "#FF4343",
  allocated: "#31778C",
  matured: "#19BC31",
  cancelled: "#A1A0A0",
};

export const NEEDS_ATTENTION_SEVERITY = {
  critical: { bg: "rgba(255, 67, 67, 0.08)", border: "#FF4343", text: "#FF4343" },
  warning: { bg: "rgba(255, 149, 0, 0.08)", border: "#ff9500", text: "#da6900" },
  info: { bg: "rgba(49, 119, 140, 0.08)", border: "#31778C", text: "#31778C" },
  neutral: { bg: "#f7f7f7", border: "#e0e0e0", text: "#525252" },
};

/** Editor stepper labels */
export const OPPORTUNITY_EDITOR_STEPS = [
  { key: "basic", label: "Basic Information" },
  { key: "financial", label: "Financial Terms" },
  { key: "dates", label: "Dates & Lifecycle" },
  { key: "content", label: "Public Content" },
  { key: "media", label: "Media & Documents" },
  { key: "review", label: "Review & Publish" },
];

/** Investor-facing content sections — maps to public detail page */
export const INVESTOR_CONTENT_SECTIONS = [
  { key: "hero", label: "Hero title & short description", fields: ["title", "shortDescription", "coverImageUrl"] },
  { key: "overview", label: "Investment overview", fields: ["overview"] },
  { key: "funds", label: "How funds will be used", fields: ["fundsUsage"] },
  { key: "highlights", label: "Investment highlights", fields: ["highlights"] },
  { key: "howItWorks", label: "How it works steps", fields: ["howItWorks"] },
  { key: "gallery", label: "Gallery", fields: ["gallery"] },
  { key: "milestones", label: "Investment timeline / milestones", fields: ["milestones"] },
  { key: "terms", label: "Terms", fields: ["terms"] },
  { key: "faqs", label: "FAQs", fields: ["faqs"] },
  { key: "risk", label: "Risk disclaimer", fields: ["riskDisclaimer"] },
];
